export default "__VITE_ASSET__BOwWpTld__"